import React, { useState } from 'react';
import Chart from 'react-apexcharts';
import { Spin } from 'antd';

const CATEGORY_COLORS = ['#00A8FF', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#FF66C3', '#4bc0c8', '#ff9f40'];

const formatPercentage = (percentage) => {
    if (typeof percentage === 'number' && !isNaN(percentage)) {
        return `${percentage.toFixed(2)}%`;
    }
    return '0.00%';
};

const Category = ({ userData, analyticsData, loading }) => {

    const [selectedCategory, setSelectedCategory] = useState(null);

    const chartSeries = analyticsData.alerts_by_categories.map(item => item.count);
    const chartLabels = analyticsData.alerts_by_categories.map(item => item.category);
    const totalAlerts = analyticsData.total_alerts;

    const handleCategoryClick = (categoryName) => {
        setSelectedCategory(prev => (prev === categoryName ? null : categoryName));
    };

    const options = {
        chart: {
            type: 'donut',
            width: 330
        },
        labels: chartLabels.length > 0 ? chartLabels : ['No Data'],
        colors: CATEGORY_COLORS,
        plotOptions: {
            pie: {
                donut: {
                    size: '65%',
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            showAlways: true,
                            label: 'Total Alerts',
                            fontSize: '14px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 600,
                            color: '#373d3f',
                            formatter: function (w) {
                                return totalAlerts.toString();
                            }
                        }
                    }
                }
            }
        },
        dataLabels: {
            enabled: false
        },
        legend: {
            show: false
        },
        responsive: [{
            breakpoint: 100,
            options: {
                chart: {
                    width: 70
                },
                legend: {
                    show: false
                }
            }
        }]
    };

    if (loading) {
        return <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '400px',
                width: '100%',
            }}
        >
            <Spin size="large" tip="Loading categories..."/>
        </div>;
    }

    return (
        <>
            <div className="row g-5">
                <div className="col-md-6">
                    <div id="chart">
                        {chartSeries.length > 0 ? (
                            <Chart options={options} series={chartSeries} type="donut" width={330}/>
                        ) : (
                            <div
                                className="w-330px h-330px d-flex align-items-center justify-content-center text-gray-500">
                                No category data available.
                            </div>
                        )}
                    </div>
                </div>
                <div className="col-md-4">
                    <p className="fs-4 fw-bold mb-7">Alerts by categories</p>
                    <div className="d-flex flex-column content-justify-center w-100">
                        {analyticsData.alerts_by_categories.map((item, index) => {
                            const isSelected = item.category === selectedCategory;
                            return (
                                <div
                                    key={item.category}
                                    className={`d-flex fs-6 fw-semibold align-items-center mb-4 p-2 rounded ${isSelected ? 'bg-light-primary border border-primary' : ''}`}
                                    onClick={() => handleCategoryClick(item.category)}
                                    style={{ cursor: 'pointer', transition: 'background-color 0.2s, border 0.2s' }}
                                >
                                    <div
                                        className="bullet w-6px h-6px rounded-2 me-3"
                                        style={{ backgroundColor: CATEGORY_COLORS[index % CATEGORY_COLORS.length] }}
                                    />
                                    <div className={`flex-grow-1 me-4 ${isSelected ? 'text-primary fw-bolder' : 'text-gray-800'}`}>{item.category}</div>
                                    <div className="fw-semibold fs-6 text-gray-700 text-xxl-end me-4">
                                        {formatPercentage(item.percentage)}
                                    </div>
                                    <div className="fw-bolder fs-5 text-gray-800 text-xxl-end min-w-100px ">
                                        {item.count}
                                    </div>
                                </div>
                            );
                        })}
                        {analyticsData.alerts_by_categories.length === 0 && (
                            <div className='text-gray-500'>No categories found.</div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Category;